// Copyright (c) 2024 Deere & Company

import MeasurementReadingView from '../state/amount-of-use';
import actions from '../../actions-list';
import {getDefaultState as getWipDefaultState} from '../state';

const updateAmountOfUseChanges = (state, action) =>
    MeasurementReadingView.update(state, {
        $set: action.data
    });

export default (state = getWipDefaultState().amountOfUseView, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_AMOUNT_OF_USE_REQUESTS]: updateAmountOfUseChanges
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/amount-of-use-updates.js